export const BRAND_NAME = 'Mazaa';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN = 'babaexch.co';
// Note: It is the hostname. Ex - diamond.mazaa.io, etc.
export const BRAND_DOMAIN_SKIN_URL = 'diamond.babaexch.co';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const OPERATORID = 'HypexDemo';
export const BACKEND_DOMAIN = 'mjmoon.art';